import { createApp } from 'vue';
import App from './App.vue';
import router, { store } from './router';
import '@/styles/index.scss';
import 'amfe-flexible';
import installPlugins from './plugins';
import FastClick from 'fastclick';
FastClick.attach(document.body);

const app = createApp(App);
installPlugins(app);

if (store) {
  app.use(store);
}
app.use(router);
app.mount('#app');
export default app;
